import { render, staticRenderFns } from "./GridCategory.vue?vue&type=template&id=2053987b&scoped=true&"
import script from "./GridCategory.vue?vue&type=script&lang=js&"
export * from "./GridCategory.vue?vue&type=script&lang=js&"
import style0 from "./GridCategory.vue?vue&type=style&index=0&id=2053987b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2053987b",
  null
  
)

export default component.exports